"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var content_supersede_list_1 = require("./content-supersede-list");
var CoDependency = /** @class */ (function (_super) {
    __extends(CoDependency, _super);
    function CoDependency(props) {
        return _super.call(this, props) || this;
    }
    CoDependency.prototype.render = function () {
        var dataList = [];
        var CoDependency = this.props.CoDependency ? this.props.CoDependency : [];
        CoDependency.forEach(function (driver, idx) {
            dataList.push(React.createElement(content_supersede_list_1.SupersedeItem, { supersede: driver }));
        });
        return (React.createElement("div", null,
            React.createElement("h3", null, l.Translator.translate("co dependency|Co Dependency")),
            React.createElement("table", { width: "100%" },
                React.createElement("tr", null,
                    React.createElement("th", null, l.Translator.translate("Description|Description")),
                    React.createElement("th", null, l.Translator.translate("psp download severity|Severity")),
                    React.createElement("th", null, l.Translator.translate("psp download version|Version")),
                    React.createElement("th", null, l.Translator.translate("release date|Release date"))),
                dataList)));
    };
    return CoDependency;
}(React.Component));
exports.CoDependency = CoDependency;
